import { useAutoneTranslation } from '@autone/translations';

import { Button } from '../../../../atoms';
import { useAdvancedFiltersInternalContext } from '../contexts/advanced-filters-internal.context';

export const AdvancedFiltersClearAllButton = () => {
  const { common } = useAutoneTranslation();
  const { dispatch } = useAdvancedFiltersInternalContext();

  return (
    <Button
      id="advanced-filters-clear-all"
      aria-label={common('clear-all')}
      className="w-fit shadow-sm text-sm h-9 font-normal"
      variant="outline"
      onClick={() => dispatch({ type: 'RESET' })}
    >
      {common('clear-all')}
    </Button>
  );
};
